import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import { ArrowRight, Filter, tick } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';

const ApprovedSalesListing = ({
  getApprovedSaleListing,
  postSalesList,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  match,
  getFetchZones = null,
}) => {
  const headers = [ 
    'Contract No',
    // 'Lead Number',
    'Site Number',
    'Client Name',
    'Created By',
    'Contract Type',
    'Assigned To',
    'Assigned To (Installation)',
    'Assigned To (Brand Activation)',
    'Creation On',
    'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isIncomplete, setIncomplete] = useState(false);
  const [activePostSales, setActivePostSales] = useState();
  const [addPostSales, setAddPostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [leadId, setleadId] = useState(null);
  const [leadType, setleadType] = useState(null);


  
  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem('roles'));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);

  const createLead = async () => {
    setActivePostSales('post-sales-corporate');
    setAddPostSales('add-contract-corporate');
    // if (departmentId && departmentId === 2) {
    //   if (teamId && teamId === 7) {
    //     setActivePostSales('post-sales-corporate');
    //     setAddPostSales('add-contract-corporate');
    //   } else if (teamId && teamId === 9) {
    //     setActivePostSales('post-sales-supply');
    //     setAddPostSales('post-sales-supply');
    //   } else if (teamId && teamId === 8) {
    //     setActivePostSales('post-sales-apartment');
    //     setAddPostSales('add-contract-apt');
    //   } else {
    //     setActivePostSales('post-sales-b2b-alliance');
    //   }
    // } else if (teamId && teamId === 16) {
    //   setActivePostSales('post-sales-supply');
    //   setAddPostSales('post-sales-supply');
    // } else if (teamId && teamId === 21) {
    //   setActivePostSales('post-sales-corporate');
    //   setAddPostSales('add-contract-corporate');
    // }
  };

  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (teamId && departmentId) {
      createLead();
    }
  }, [teamId, departmentId]);

  // useEffect(() => {
  //   if (getApprovedSaleListing !== null) {
  //     (async () => {
  //       setIsLoading(true);
  //       await getApprovedSaleListing(leadId,null, 1);
  //       setIsLoading(false);
  //     })();
  //   }
  // }, [getApprovedSaleListing]);
  useEffect(() => {
    setleadId(match.params.id);
    setleadType(match.params.leadType);
  }, [match.params.id, match.params.leadType]);

  useEffect(() => {
    if (leadId !== null) {
      (async () => {
        setIsLoading(true);
        await getApprovedSaleListing(leadId, null, 1);
        setIsLoading(false);
      })();
    }
  }, [leadId]);

  useEffect(() => {
    const tableData = [
      'id',
      'comm_id',
      'site_no',
      'client_name',
      'created_by',
      'commercial_type_name',
      'assigned_to',
      'assigned_to_installation',
      'assigned_to_ba',
      'created_at',
      'status',
    ];

    let roleId = parseInt(localStorage.getItem('fusion-role'));
  
    if (postSalesList && postSalesList.incomplete && postSalesList.incomplete === 1) {
      setIncomplete(1);
    }else{
      setIncomplete(0);
    }
  
    if (postSalesList &&  postSalesList?.resultSets && postSalesList.resultSets.length > 0) {
      const data = postSalesList?.resultSets.map((element) =>
       
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          element.status == "Modification Pending" ? 
            element.lead_type_id == 1 
            ? {
              Action: [
                { name: 'View Details', link: '/dashboard/contract-details/'+element.comm_id },
                // { name: "Edit Contract", link: '/dashboard/edit-contract-corp/'+element.comm_id},
                { name: 'Edit Contract', link: '/dashboard/edit-contract-corporate-v2/' + element.comm_id }
              ]
              }  
            : 
              element.lead_type_id == 2 
              ?
              { 
                Action: [
                  { name: 'View Details', link: '/dashboard/contract-details/'+element.comm_id },
                  // { name: "Edit Contract", link: '/dashboard/edit-contract-apt/'+element.comm_id},
                  { name: 'Edit Contract', link: '/dashboard/edit-contract-corporate-v2/' + element.comm_id }
                ]
              }
              :
              {
                Action: [
                  { name: 'View Details', link: '/dashboard/contract-details/'+element.comm_id },
                  // { name: "Edit Contract", link: '/dashboard/edit-contract-supply/'+element.comm_id},
                  { name: 'Edit Contract', link: '/dashboard/edit-contract-corporate-v2/' + element.comm_id }
                ]
              }
            
          : {
            Action: [
              { name: 'View Details', link: '/dashboard/contract-details/'+element.comm_id },
              // { name: 'Edit Contract', link: '/dashboard/edit-contract-corporate-v2/' + element.comm_id }
            ]
          },
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(postSalesList.total / postSalesList.per_page));
    }
  }, [postSalesList]);
  

 
  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getApprovedSaleListing(leadId, filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(2);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const checkLead =(leadType,leadId) => {
    <a
      href={`/dashboard/add-contract-corporate/`+leadId}
      className="btn btn-primary d-none d-md-inline-block"
      >Add New Contract</a> 
  //   if(leadType == 1){
  //     <a
  //     href={`/dashboard/add-contract-corporate/`+leadId}
  //     className="btn btn-primary d-none d-md-inline-block"
  //     >Add New Contract</a> 
  //   }else if(leadType == 2){
  //      <a
  //     href={`/dashboard/add-contract-corporate/`+leadId}
  //     className="btn btn-primary d-none d-md-inline-block"
      
  //     >Add New Contract</a> 
  //   }else if(leadType == 5){
  //     <a
  //    href={`/dashboard/add-contract-corporate/`+leadId}
  //    className="btn btn-primary d-none d-md-inline-block"
     
  //    >Add New Contract</a> 
  //  }else if(leadType == 3){
  //     <a
  //     href={`/dashboard/add-contract-corporate/`+leadId}
  //     className="btn btn-primary d-none d-md-inline-block"
      
  //     >Add New Contract</a>
  //   }else{
  //     <a
  //     href={`/dashboard/add-contract-corporate/`+leadId}
  //     className="btn btn-primary d-none d-md-inline-block"
      
  //     >Add New Contract</a>
  //   }
  }

  // UI WORK START
  const headerBtns2 = () => {
    return (
      
      <Fragment>
        {/* {console.log(leadId)} */}
        {leadId && leadId != null && leadType && leadType != null &&  isIncomplete  != 1 && ( 
          // checkLead(leadType,leadId)
          <>
          <a
            href={`/dashboard/add-contract-corporate-v2/`+leadId}
            className="btn btn-primary d-none d-md-inline-block"
            >Add Contract</a>
          {/* {leadType == 1 ? (
            <a
            href={`/dashboard/add-contract-corporate-v2/`+leadId}
            className="btn btn-primary d-none d-md-inline-block"
            >Add Contract</a> 
          )
          :
          leadType == 2 ? (
            // <a
            // href={`/dashboard/add-contract-apt/`+leadId}
            // className="btn btn-primary d-none d-md-inline-block"
            
            // >Add New Contract</a> 
             <a
            href={`/dashboard/add-contract-corporate-v2/`+leadId}
            className="btn btn-primary d-none d-md-inline-block"
            
            >Add Contract</a> 
          ) :leadType == 5 ? (
            
             <a
            href={`/dashboard/add-contract-corporate-v2/`+leadId}
            className="btn btn-primary d-none d-md-inline-block"
            
            >Add Contract</a> 
          ) : leadType == 3 ? (
            <a
            href={`/dashboard/post-sales-supply/`+leadId}
            className="btn btn-primary d-none d-md-inline-block"
            
            >Add Contract</a>
          ): <>
            <a
            href={`/dashboard/post-sales-supply/`+leadId}
            className="btn btn-primary d-none d-md-inline-block"
            
            >Add Contract</a>
            </>
          } */}
          </>
        )}
        {leadId && leadId != null &&  isIncomplete  == 1 && (
            <>
            <a
              href={`/dashboard/add-contract-corporate-v2/`+leadId}
              className="btn btn-primary d-none d-md-inline-block"
              >Complete Prev. Contract</a> 
            {/* {leadType == 1 ? (
              <a
              href={`/dashboard/add-contract-corporate-v2/`+leadId}
              className="btn btn-primary d-none d-md-inline-block"
              >Complete Prev. Contract              </a> 
            )
            :
            leadType == 2 ? (
              <a
              href={`/dashboard/add-contract-corporate-v2/`+leadId}
              className="btn btn-primary d-none d-md-inline-block"
              
              >Complete Prev. Contract              </a> 
              //  <a
              // href={`/dashboard/add-contract-apt/`+leadId}
              // className="btn btn-primary d-none d-md-inline-block"
              
              // >Complete Prev. Contract              </a> 
            ) : leadType == 5 ? (
              <a
              href={`/dashboard/add-contract-corporate-v2/`+leadId}
              className="btn btn-primary d-none d-md-inline-block"
              
              >Complete Prev. Contract              </a> 
              
            ) : leadType == 3 ? (
              <a
              href={`/dashboard/post-sales-supply/`+leadId}
              className="btn btn-primary d-none d-md-inline-block"
              
              >Complete Prev. Contract
              </a>
            ): <>
              <a
              href={`/dashboard/post-sales-supply/`+leadId}
              className="btn btn-primary d-none d-md-inline-block"
              
              >Complete Prev. Contract
              </a>
              </>
            } */}
            </>
        )}
       
        {/* <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button> */}
        {/* <a
          href=""
          className="btn btn-primary d-none d-md-inline-block"
          data-toggle="modal"
          data-target="#bulkAssignment"
        >
          Bulk Assignment <img src={ArrowRight} alt=""></img>
        </a>
        <a href="" className="filter-hamburger btn btn-transparent">
          <img src={Filter} alt=""></img>
          Show Filters
        </a> */}
      </Fragment>
    );
  };
  // UI WORK END

  const headerBtns = () => {
    return (
      
      <Fragment>
        {/* {console.log(leadId)} */}
        {leadId && leadId != null && leadType && leadType != null &&  isIncomplete  != 1 && ( 
          // checkLead(leadType,leadId)
          <>
          {leadType == 1 ? (
            <a
            href={`/dashboard/add-contract-corporate/`+leadId}
            className="btn btn-primary d-none d-md-inline-block"
            >Add New Contract</a> 
          )
          :
          leadType == 2 ? (
             <a
            href={`/dashboard/add-contract-apt/`+leadId}
            className="btn btn-primary d-none d-md-inline-block"
            
            >Add New Contract</a> 
          ) : leadType == 3 ? (
            <a
            href={`/dashboard/post-sales-supply/`+leadId}
            className="btn btn-primary d-none d-md-inline-block"
            
            >Add New Contract</a>
          ): <>
            <a
            href={`/dashboard/post-sales-supply/`+leadId}
            className="btn btn-primary d-none d-md-inline-block"
            
            >Add New Contract</a>
            </>
          }
          </>
        )}
        {leadId && leadId != null &&  isIncomplete  == 1 && (
            <>
            {leadType == 1 ? (
              <a
              href={`/dashboard/add-contract-corporate/`+leadId}
              className="btn btn-primary d-none d-md-inline-block"
              >Complete Prev. Contract              </a> 
            )
            :
            leadType == 2 ? (
               <a
              href={`/dashboard/add-contract-apt/`+leadId}
              className="btn btn-primary d-none d-md-inline-block"
              
              >Complete Prev. Contract              </a> 
            ) : leadType == 3 ? (
              <a
              href={`/dashboard/post-sales-supply/`+leadId}
              className="btn btn-primary d-none d-md-inline-block"
              
              >Complete Prev. Contract
              </a>
            ): <>
              <a
              href={`/dashboard/post-sales-supply/`+leadId}
              className="btn btn-primary d-none d-md-inline-block"
              
              >Complete Prev. Contract
              </a>
              </>
            }
            </>
        )}
       
        {/* <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button> */}
        {/* <a
          href=""
          className="btn btn-primary d-none d-md-inline-block"
          data-toggle="modal"
          data-target="#bulkAssignment"
        >
          Bulk Assignment <img src={ArrowRight} alt=""></img>
        </a>
        <a href="" className="filter-hamburger btn btn-transparent">
          <img src={Filter} alt=""></img>
          Show Filters
        </a> */}
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getApprovedSaleListing(leadId, filter, val.selected + 1);
    setIsLoading(false);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.contractListing}
      Buttons={headerBtns2}
      isGoback
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        detailList={postSalesList && postSalesList.resultSets}
        pageCount={pageCount}
        srNo={postSalesList?.from}
        onPageChange={onPageChange}
      />

      {/* <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'5'}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        isRoleId={isRoleId}
        filterPreSalesListing
      /> */}

      <ModalPop
        title={localization.updatedSuccessfully}
        show={isStatusSuccess}
        handleModalHide={closeSuccess}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadStatusupdatedsuccessfully}</h5>
          <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
            {localization.continue}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default ApprovedSalesListing;
